export const strings = {
  title: 'Konferans Bildirileri',
  see_all: 'Tümünü Gör',
  no_conference_proceeding: 'Konferans Bildirisi Yok',
  no_conference_proceeding_message: 'Konferans Bildirisi Bulunamadı',
  conference_title: 'Konferans Bildiri Başlığı',
  title_placeholder: 'Konferans bildiri başlığını girin',
  submit: 'Gönder',
  errors: {
    title_required: 'Başlık gerekli',
    url_required: 'URL gereklidir',
    title_min_length: 'Başlık en az 3 karakter olmalıdır',
    title_max_length: 'Başlık 250 karakterden uzun olamaz',
    brief_required: 'Konferans Bildiri Özeti gereklidir',
    brief_min_length: 'Konferans Bildiri Özeti en az 3 karakter olmalıdır',
    brief_max_length: 'Konferans Bildiri Özeti 250 karakterden fazla olamaz',
    url: 'Kaynak geçerli bir URL olmalıdır',
    url_max_limit: 'Kaynak 300 karakterden fazla olamaz',
    description_required: 'Konferans Bildiri açıklaması gereklidir',
    description_min_length:
      'Konferans Bildiri Açıklaması en az 3 karakter olmalıdır',
    description_max_length:
      'Konferans Bildiri Açıklaması 2500 karakterden fazla olamaz',
    speciality_id_required: 'Lütfen bir uzmanlık alanı seçin',
  },
  delete: 'Konferans tutanağını sil',
  delete_confirmation_heading: 'Bu işlemi silmek istediğinizden emin misiniz?',
  delete_confirmation_body:
    'Silindikten sonra bu konferans işlemine erişemezsiniz.',
  cancel: 'İptal',
  search_proceeding: 'Arama Konferansı Bildirileri',
};
